var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{attrs:{"close-delay":"200"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-card',{staticClass:"mx-auto",class:{ 'on-hover': hover },attrs:{"elevation":hover ? 8 : 2,"height":_vm.height,"width":_vm.width},on:{"click":_vm.onClick}},[_c('img',{attrs:{"src":_vm.src}})])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }